import React, { useEffect, useState } from "react";
import "./bulkReschedule.scss";
import bulk_reschedule_calendar from "../../../../assets/bulk_reschedule_calendar.svg";
import Calendar from "react-calendar";
import dateFormat from "dateformat";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import Popover from "react-popover";
import Info from "../../../../assets/info.png";
import BulkRescheduleModal from "../Modals/BulkRescheduleModal";
import swal from "sweetalert";
import Loader from "../../../UI Component/Loader/Loader";
import ViewLogs from "../ViewLogs";
import { BULK_RESCHEDULE } from "../Constants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import moment from "moment";
const BulkReschedule = (props) => {
  const { clinic_id, staffDoctor } = props;
  const [dateValue, setDateValue] = useState();
  const [rescheduledateValue, setRescheduleDateValue] = useState("");
  const [addClass, setAddClass] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showRescheduleCalendar, setShowRescheduleCalendar] = useState(false);
  const [openPopOver, setOpenPopOver] = useState(false);
  const [calendarLoader, setCalendarLoader] = useState(false);
  const [tempDate, setTempDate] = useState();
  const [availableDate, setAvailableDate] = useState([]);
  const [rescheduledPopUp, setRescheduledPopUp] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const user_type = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  const popoverContent =
    "Greyed-out dates indicate that there are appointments scheduled on that date or that there is a difference in procedures, schedules, or duration from the date where appointments need to be rescheduled.";

  // Actions ===>

  const toggleCalendar = () => {
    setShowRescheduleCalendar(false);
    setShowCalendar(!showCalendar);
  };

  const toggleRescheduleCalendar = () => {
    setShowCalendar(false);
    setShowRescheduleCalendar(!showRescheduleCalendar);
    if (!showRescheduleCalendar) {
      retrieveDates(new Date());
    }
  };

  const handleDateSelection = (val) => {
    if (dateFormat(new Date(val), "yyyy-mm-dd") !== dateValue) {
      setRescheduleDateValue("");
    }
    setDateValue(dateFormat(new Date(val), "yyyy-mm-dd")); //"mmm dd, yyyy"
    if (!rescheduledateValue) {
      setTempDate(dateFormat(new Date(val), "yyyy-mm-dd"));
    }
    setShowCalendar(false);
  };

  const handleRescheduleDateSelection = (val) => {
    setRescheduleDateValue(dateFormat(new Date(val), "yyyy-mm-dd"));
    setTempDate(dateFormat(new Date(val), "yyyy-mm-dd"));
    setShowRescheduleCalendar(false);
  };

  const retrieveDates = (value) => {
    setCalendarLoader(true);
    var date = new Date(value);
    var firstDay = dateFormat(
      new Date(date.getFullYear(), date.getMonth(), 1),
      "yyyy-mm-dd"
    );
    var lastDay = dateFormat(
      new Date(date.getFullYear(), date.getMonth() + 1, 0),
      "yyyy-mm-dd"
    );
    let params = {
      doctor_id:
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN ||
        user_type === "staff"
          ? staffDoctor.id
          : userId, //need to change doctor id
      clinic_id: clinic_id ? clinic_id : null,
      reschedule_from: dateValue, //"2022-09-07",
      start_date: firstDay, //"2022-09-01",
      end_date: lastDay, //"2022-09-30",
      "authorizer-principal-id": {
        user_type: user_type === "doctor" ? 1 : 4, //changes based on staff or doctor
      },
    };
    afterLoginApiAxios
      .post("/api/v1/appointments/reschedule/availabilities", params, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          if (res?.data?.calendar_availabilities?.length > 0) {
            let arr = [];
            res.data.calendar_availabilities.forEach((data) => {
              Object.entries(data).forEach(([key, value]) => {
                if (value === false) {
                  arr.push(key);
                }
              });
            });
            setAvailableDate(arr);
          }
        } else {
          swal({
            title: "Something went wrong",
            icon: "error",
            button: "Okay",
          });
        }
        setCalendarLoader(false);
      })
      .catch((err) => {
        setCalendarLoader(false);
        C2CConsole.log(err);
      });
  };

  const handleReschedule = () => {
    if (dateValue && rescheduledateValue) {
      setPageLoader(true);
      let params = {
        doctor_id:
          doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN ||
          user_type === "staff"
            ? staffDoctor.id
            : userId,
        clinic_id: clinic_id ? clinic_id : null,
        reschedule_from: dateValue, //"2022-09-07",
        reschedule_to: rescheduledateValue, //"2022-09-09",
        user_type: user_type,
        staff_id: user_type === "staff" && staffId,
        "authorizer-principal-id": {
          user_type: user_type === "doctor" ? 1 : 4, //changes based on staff or doctor
          user_id: userId,
        },
        user_agent: "web",
      };
      afterLoginApiAxios
        .post("/api/v1/appointments/reschedule/bulk", params, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        })
        .then((res) => {
          if (res?.data?.statusCode === 200) {
            setRescheduledPopUp(true);
          } else {
            swal({
              title: "Something went wrong",
              icon: "error",
              button: "Okay",
            });
          }
          setPageLoader(false);
        })
        .catch((err) => {
          C2CConsole.log(err);
        });
    }
  };

  // <===

  // Display UI ===>

  const displayBulkReschedule = () => {
    return (
      <div className="bulk-reschedule-cont">
        {displayHeaderContent()}
        {displayRescheduleContent()}
      </div>
    );
  };

  const displayHeaderContent = () => {
    return (
      <>
        <div className="d-flex justify-content-between">
          <div className="bulk-reschedule-header">
            Bulk Reschedule for All appointments for a day
          </div>
          <div
            className="view-logs-title"
            onClick={() => {
              if (window.innerWidth > 767) {
                setAddClass("btm-drawer");
                props.setShowBackDrop("btm-drawer");
                props.handleViewLogOpened();
              } else {
                props.setShowLogsMobile(true);
              }
            }}
          >
            View Logs
          </div>
          {window.innerWidth < 768 && <div>{renderInfoIcon()}</div>}
        </div>
        <div className="bulk-reschedule-subheader">
          First, choose a date on which you want to reschedule all your
          appointments, then choose a date on which you want to pour all your
          appointments.
        </div>
      </>
    );
  };

  const displayRescheduleContent = () => {
    return (
      <div className="reschedule-content">
        {displayFromCalendar()}
        {displayRescheduleCalendar()}
        {RescheduleButton()}
      </div>
    );
  };

  const displayFromCalendar = () => {
    return (
      <div className="date-calander">
        <div className="select-date-header">Select a Date</div>
        <div
          className="bulk-reschedule-calendar-input"
          onClick={toggleCalendar}
        >
          <div
            className={
              "bulk-reschedule-calendar-input-value " +
              (dateValue ? "date-selected-value" : "date-placeholder")
            }
            // onClick={toggleCalendar}
          >
            {dateValue
              ? dateFormat(new Date(dateValue), "mmm dd, yyyy")
              : "Select a Date"}
          </div>
          <div>
            <img src={bulk_reschedule_calendar} alt="" />
          </div>
        </div>
        {showCalendar && (
          <div
            className={`bulk-reschedule-calendar ${
              dateValue && dateValue !== dateFormat(new Date(), "yyyy-mm-dd")
                ? "disable-highlight"
                : ""
            }`}
          >
            <Calendar
              onChange={handleDateSelection}
              value={dateValue ? new Date(dateValue) : new Date()}
              // defaultValue={new}
              minDate={new Date()}
              maxDate={moment(new Date()).add(12, "months")._d}
              showNeighboringMonth={false}
            />
          </div>
        )}
      </div>
    );
  };

  const displayRescheduleCalendar = () => {
    return (
      <div>
        <div className="d-flex justify-content-between">
          <div className="select-date-header">Select a Reschedule Date</div>
          {window.innerWidth > 768 && <div>{renderInfoIcon()}</div>}
        </div>
        <div
          className={` ${!dateValue ? "diable-icon" : ""}`}
          // style={{ cursor: "not-allowed" }}
        >
          <div
            className={`bulk-reschedule-calendar-input ${
              !dateValue ? "diable-reschedule" : ""
            }`}
            // className="bulk-reschedule-calendar-input"
            onClick={toggleRescheduleCalendar}
          >
            <div
              className={
                "bulk-reschedule-calendar-input-value " +
                (rescheduledateValue
                  ? "date-selected-value"
                  : "date-placeholder")
              }
              // onClick={toggleRescheduleCalendar}
            >
              {rescheduledateValue
                ? dateFormat(new Date(rescheduledateValue), "mmm dd, yyyy")
                : "Select a Reschedule Date"}
            </div>
            <div className={`${!dateValue ? "disable-cal-icon" : ""}`}>
              <img src={bulk_reschedule_calendar} alt="" />
            </div>
          </div>
        </div>
        {showRescheduleCalendar && (
          <div
            className={`bulk-reschedule-calendar ${
              rescheduledateValue !== dateFormat(new Date(), "yyyy-mm-dd")
                ? "disable-highlight"
                : ""
            }`}
          >
            <div className="wh">
              {calendarLoader && (
                <div className={"calendar-container wh"}>
                  <div className="calendar-loader wh">
                    <div class="spinner-border text-dark" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              )}
              <Calendar
                onChange={handleRescheduleDateSelection}
                value={rescheduledateValue ? new Date(rescheduledateValue) : ""}
                minDate={new Date()}
                maxDate={moment(new Date()).add(12, "months")._d}
                showNeighboringMonth={false}
                tileDisabled={({ date }) => {
                  return availableDate.includes(dateFormat(date, "yyyy-mm-dd"));
                }}
                onActiveStartDateChange={({
                  action,
                  activeStartDate,
                  value,
                  view,
                }) => {
                  retrieveDates(
                    dateFormat(new Date(activeStartDate), "yyyy-mm-dd")
                  );
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  const RescheduleButton = () => {
    return (
      <div className={"reschedule-btn-container"}>
        <button className="reschedule-btn" onClick={handleReschedule}>
          Reschedule
        </button>
      </div>
    );
  };

  const renderInfoIcon = () => {
    return (
      <Popover
        isOpen={openPopOver} //{true}
        preferPlace={`below`}
        place={null}
        body={<PopoverContent />}
      >
        <img
          src={Info}
          alt=""
          className="ml-2"
          style={{ width: "14px" }}
          onMouseOver={() => {
            setOpenPopOver(true);
          }}
          onMouseOut={() => {
            setOpenPopOver(false);
          }}
        />
      </Popover>
    );
  };

  const PopoverContent = () => {
    return <div className="info-content">{popoverContent}</div>;
  };

  // <===

  return (
    <>
      {pageLoader && <Loader />}
      {displayBulkReschedule()}
      {
        <BulkRescheduleModal
          show={rescheduledPopUp}
          fromDate={dateValue}
          toDate={rescheduledateValue}
          okayClickHandler={() => setRescheduledPopUp(false)}
        />
      }
      <ViewLogs
        addClass={addClass}
        setAddClass={() => {
          props.handleViewLogOpened();
          props.setShowBackDrop("");
          setAddClass("");
        }}
        logType={BULK_RESCHEDULE}
        roleNameMenu={props.roleNameMenu}
        tableData={props.tableData}
        handleViewLogOnFilter={props?.handleViewLogOnFilter}
        logFilterData={props?.logFilterData}
        totalRecords={props?.totalRecords}
      ></ViewLogs>
    </>
  );
};

export default BulkReschedule;
